// Import the functions you need from the SDKs you need
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, signInWithCustomToken } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import messagesAPI from './messages';

export default (function firebaseInstanceModule() {
	const firebaseConfigSandbox = {
		apiKey: 'AIzaSyCuoWNY9ya_2G-fm3d6WGdKDmsiQHFn_Jg',
		authDomain: 'api-test-71bee.firebaseapp.com',
		projectId: 'api-test-71bee',
		storageBucket: 'api-test-71bee.appspot.com',
		messagingSenderId: '574257702403',
		appId: '1:574257702403:web:cae970c66a095d8e065036',
		measurementId: 'G-TPGFH6MY37'
	};

	var app: FirebaseApp = null;
	var db = null;

	async function getFirebaseToken() {
		const response = await messagesAPI.getFirebaseToken();
		if (response && response.data) {
			return response.data.firebaseCustomToken;
		} else return null;
	}

	async function get(): Firestore {
		if (!app || !db) {
			// Initialize Firebase
			app = initializeApp(firebaseConfigSandbox);

			const firebaseToken = await getFirebaseToken();

			await signInWithCustomToken(getAuth(), firebaseToken);
			db = getFirestore(app);
		}
		return db;
	}
	return { get };
})();
